import { SearchModes } from '@/domainLogic/index.ts';
import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import { hasDealsWithVoucherExtra } from '../../SearchPageContainer/ListContainer/utils';
import type { Localization } from '../../../common/Localization';
import getSearchParams from '../../../common/getSearchParams';

type CreateShowVoucherExtraBanner = {
  searchInfoData: SearchInfoData;
  productsData: ProductsData;
  localization: Localization;
};
export const createShowVoucherExtraBanner = ({
  searchInfoData,
  productsData,
  localization,
}: CreateShowVoucherExtraBanner): boolean => {
  const hasNoResults = productsData?.dealCards?.length === 0;
  const searchParams = getSearchParams();

  return (
    !hasNoResults &&
    localization?.configValuesApp?.voucherExtraEnabled &&
    searchParams[URLParameters.SEARCH_MODE] === SearchModes.DP &&
    hasDealsWithVoucherExtra(productsData) &&
    searchInfoData.isLiveSearch
  );
};
